module.exports = __webpack_public_path__ + "img/fire_tool_7.b998bbfe.png";